import auth from '@middlewares/Auth';

export default [
  {
    url: '/tours',
    page: 'tours/Index',
    name: 'tours',
    meta: {
      label: 'Tours List',
      layout: 'Dashboard',
      middleware: [auth],
      role: {
        only: ['tourism-operator'],
      },
    },
    group: [
      {
        url: 'create',
        page: 'tours/Create',
        name: 'new-tours',
        only: ['tourism-operator'],
      },
    ],
  },
];
